import * as stylex from "@stylexjs/stylex";

import { badge, button, table, text } from "@animus/primaris";

import type { ModifierDefinition } from "./types.ts";
import { styles } from "./styles.stylex.ts";

function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) {
    return str;
  }
  return `${str.slice(0, maxLength)}…`;
}

function getCategoryBadgeStyle(category: string) {
  switch (category) {
    case "cooking":
      return badge.blue;
    case "preparation":
      return badge.purple;
    case "addition":
      return badge.orange;
    default:
      return badge.neutral;
  }
}

interface ModifierRowProps {
  modifier: ModifierDefinition;
  onViewDetails: () => void;
}

function ModifierRow({ modifier, onViewDetails }: ModifierRowProps) {
  return (
    <tr {...stylex.props(table.tr)}>
      <td {...stylex.props(table.td)}>
        <span {...stylex.props(text.white, text.bold)}>{modifier.name}</span>
      </td>
      <td {...stylex.props(table.td)}>
        <span {...stylex.props(text.muted, styles.slugCell)}>
          {modifier.slug}
        </span>
      </td>
      <td {...stylex.props(table.td)}>
        <span
          {...stylex.props(
            badge.base,
            getCategoryBadgeStyle(modifier.category)
          )}
        >
          {modifier.category}
        </span>
      </td>
      <td {...stylex.props(table.td)}>
        <span {...stylex.props(text.muted)}>
          {modifier.exclusiveGroup ?? "—"}
        </span>
      </td>
      <td {...stylex.props(table.td)}>
        <span {...stylex.props(text.white)}>{modifier.rules.length}</span>
      </td>
      <td {...stylex.props(table.td)}>
        <span {...stylex.props(text.sm, text.muted)}>
          {truncate(modifier.description, 40)}
        </span>
      </td>
      <td {...stylex.props(table.td, table.tdRight)}>
        <button
          {...stylex.props(button.base, button.secondary, button.small)}
          onClick={onViewDetails}
          type="button"
        >
          View
        </button>
      </td>
    </tr>
  );
}

export { ModifierRow, type ModifierRowProps };
